import { MktLogo } from '@playbooks/components/mkt/mkt-logo';
import { MktNavbarList } from '@playbooks/components/mkt/mkt-navbar-list';
import { cn } from '@playbooks/ui/lib/utils';

const MktNav = ({ className = '' }) => {
	// Theme
	const rootClassName = cn('z-10 flex-start h-16 w-full border-b bg-canvas px-3', className);

	// Render
	return (
		<nav className={rootClassName}>
			<div className='mx-auto flex-between h-full w-full max-w-xl gap-6 px-3'>
				<MktLogo />
				<MktNavbarList />
			</div>
		</nav>
	);
};
export { MktNav };
